const { mapGetters } = require("vuex");

module.exports = {
  computed: {
    ...mapGetters({
      account: 'getAccount',
    })
  },

  methods: {
    getRecaptchaSiteKey(version = 'v3') {
      const accountKeyTypeId = version === 'v3' ? 4 : 6;

      const accountKey = this.account.AccountKeys.filter((key) => {
        return key.account_key_type_id === accountKeyTypeId;
      });

      if (accountKey.length === 0) {
        console.error(`No reCAPTCHA ${version} site key found in account keys.`);
        return null;
      }

      return accountKey[0].value;
    },

    freedom_handleRecaptcha(v2_token = null) {
      this.submitted = true;
      this.recaptchaChallenge = false;


      if (this.account?.recaptcha_enabled && !v2_token) {
        grecaptcha.ready(() => {
          grecaptcha
            .execute(this.getRecaptchaSiteKey('v3'), { action: 'submit' })
            .then((v3_token) => {
              this.recaptchaToken = v3_token;
              this.recaptchaTokenVersion = 'v3';
              this.finaliseFreedomPay();
            });
        });
      } else {
        if (v2_token) grecaptcha.reset();
        this.recaptchaToken = v2_token;
        this.recaptchaTokenVersion = 'v2';
        this.finaliseFreedomPay();
      }
    },



    freedom_handleRecaptchaChallenge(orderResponse) {
      if (orderResponse?.recaptcha_action === 'CHALLENGE') {
        this.submitted = false;
        this.recaptchaChallenge = true;


        grecaptcha.ready(() => {
          try {
            grecaptcha.render('recaptcha-v2', {
              sitekey: this.getRecaptchaSiteKey('v2'),
              callback: this.freedom_handleRecaptcha,
            });
          } catch (e) {
            // Already rendered
          }
        });

        return true;
      }

      return false;
    }
  }
}
